// extracted by mini-css-extract-plugin
export var danger = "_3p-6";
export var lightPink = "_3p-a";
export var medium = "_3p-j";
export var nearSquare = "_3p-m";
export var neutralBlue = "_3p-8";
export var neutralYellow = "_3p-7";
export var noCapitalize = "_3p-1";
export var normal = "_3p-2";
export var pill = "_3p-0";
export var primary = "_3p-3";
export var primaryLight = "_3p-4";
export var shadow = "_3p-n";
export var small = "_3p-k";
export var solidBlack = "_3p-i";
export var solidGreen = "_3p-d";
export var solidLightBlue = "_3p-f";
export var solidNavy = "_3p-e";
export var solidOrange = "_3p-h";
export var solidPink = "_3p-g";
export var solidRed = "_3p-b";
export var solidWhite = "_3p-9";
export var solidYellow = "_3p-c";
export var success = "_3p-5";
export var xsmall = "_3p-l";